import React, { ReactNode } from 'react';
import SelectionGroupBase from './SelectionGroupBase';

type TDumbSelectionGroup = {
  errorText?: string;
  children: ReactNode;
  display?: string;
};

const DumbSelectionGroup = ({ children, errorText }: TDumbSelectionGroup) => (
  <SelectionGroupBase errorText={errorText}>{children}</SelectionGroupBase>
);

export default DumbSelectionGroup;
